import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-final-text',
  templateUrl: './final-text.component.html',
  styleUrls: ['./final-text.component.scss']
})
export class FinalTextComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

 

}
